import { Box, Divider, Typography, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { ValidLensTreatment, ValidLensMaterial, ValidLensIndex, ValidLensModel, LensPricingMatrix } from '../lens';

export default function Lenses(props) {

    const [tabValue, setTabValue] = useState(0);

    function TabPanel({ children, value, index }) {
        return (
            <div role="tabpanel" hidden={value !== index}>
                {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
            </div>
        );
    }

    return (
        <Box>
            <Typography variant="h4">Lenses</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Inventory and admin pages for lenses
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Tabs value={tabValue} onChange={(e, nv) => setTabValue(nv)} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                {/* <Tab label="Inventory" /> */}
                {/* <Tab label="Brands" /> */}
                <Tab label="Treatments" />
                <Tab label="Materials" />
                <Tab label="Indexes" />
                <Tab label="Models" />
                <Tab label="Pricing" />
            </Tabs>

            <TabPanel value={tabValue} index={0}>
                <ValidLensTreatment />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <ValidLensMaterial />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
                <ValidLensIndex />
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
                <ValidLensModel />
            </TabPanel>
            <TabPanel value={tabValue} index={4}>
                <LensPricingMatrix />
            </TabPanel>
        </Box>
    )
}